import { render, staticRenderFns } from "./TutoriaDetalle.vue?vue&type=template&id=582bc4da&"
import script from "./TutoriaDetalle.vue?vue&type=script&lang=js&"
export * from "./TutoriaDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports